<template>
  <section>
    <v-container>
      <div class="px-4 item">
        <v-sheet class="mx-auto" color="transparent" max-width="1000px">
          <div class="align-center justify-center item-grid-list">
            <div class="d-flex flex-column pr-md-16 item-content">
              <TitleWidget v-if="!withoutTitle" align="center">
                {{ title }}
              </TitleWidget>

              <template v-if="contacts.length">
                <div class="mx-n4" :class="{ 'mt-4 mt-md-6': !withoutTitle }">
                  <div v-for="(item, keyContact) in contacts" :key="keyContact">
                    <v-btn
                      v-if="!Array.isArray(item)"
                      class="
                        secondary--text
                        text-body-1 text-none
                        font-weight-medium
                        btn-contact
                      "
                      :class="{ 'mt-2': keyContact > 0 }"
                      height="auto"
                      min-height="36px"
                      :href="item.link"
                      :target="item.target"
                      :title="item.name"
                      depressed
                      color="transparent"
                    >
                      <v-icon
                        v-if="item.icon"
                        class="mr-2"
                        color="secondary"
                        :size="item.size"
                      >
                        {{ item.icon }}
                      </v-icon>

                      <span v-html="item.text"></span>
                    </v-btn>

                    <div v-else class="d-flex align-center">
                      <div
                        class="d-inline-flex align-center justify-start"
                        v-for="(
                          { name, text, link, target, icon, size },
                          keyContactItem
                        ) in item"
                        :key="keyContactItem"
                      >
                        <v-sheet
                          v-if="keyContactItem > 0"
                          color="secondary lighten-4"
                          width="1px"
                          height="26px"
                        ></v-sheet>

                        <v-btn
                          class="
                            secondary--text
                            text--lighten-2 text-body-2 text-none
                            btn-contact
                          "
                          height="auto"
                          min-height="36px"
                          :href="link"
                          :target="target"
                          :title="name"
                          depressed
                          color="transparent"
                        >
                          <v-icon
                            v-if="icon"
                            class="mr-2"
                            color="primary"
                            :size="size"
                          >
                            {{ icon }}
                          </v-icon>

                          <span v-html="text"></span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div v-if="informations.opening_hours.length">
                <div
                  class="
                    secondary--text
                    text--lighten-2 text-subtitle-1
                    font-weight-bold
                    mt-4 mt-md-6
                    mb-3
                  "
                >
                  Horário de Atendimento:
                </div>
                <div
                  v-for="opening_hour in informations.opening_hours"
                  :key="opening_hour"
                  class="
                    secondary--text
                    text--lighten-2 text-body-1
                    font-weight-medium
                    mt-1
                  "
                >
                  {{ opening_hour }}
                </div>
              </div>
            </div>

            <template v-if="informations.map">
              <v-sheet
                class="rounded-lg item-map"
                color="secondary lighten-3"
                v-html="informations.map"
              ></v-sheet>
            </template>
          </div>
        </v-sheet>
      </div>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import { getContact } from "../../utils/getContact";

const _data = {
  title: "Entre em Contato",
};

export default {
  props: {
    withoutTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ..._data,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-grid-list {
    display: grid;
    gap: 0;
    grid-template-columns: 47% 53%;

    @media screen and (max-width: 960px) {
      gap: 20px;
      grid-template-columns: minmax(0, 600px);
    }
  }

  &-map::v-deep {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;

    @media screen and (max-width: 960px) {
      aspect-ratio: 16 / 9;
    }

    iframe {
      display: block;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      width: 100%;
    }
  }

  &.item-opposite {
    .item-grid-list {
      grid-template-columns: 55% 45%;
    }

    .item-img {
      order: 0;
    }

    .item-content {
      order: 12;
    }
  }
}

.btn-contact::v-deep {
  .v-btn__content {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
